module.exports = __webpack_public_path__ + "img/step-4.fc8a5f35.svg";